var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEducationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.09,
    height: 43.177,
    viewBox: "0 0 65.09 43.177",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.851,89.156a2.749,2.749,0,0,1-1.188-.271L34.77,78.86v9.014h.006c.153,5.777,9.673,10.437,21.4,10.437s21.244-4.66,21.4-10.437h.006V79.51L58.042,88.885A2.772,2.772,0,0,1,56.851,89.156Z",
    transform: "translate(-24.309 -55.134)",
    fill: "#1e4171"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.566,15.266,32.939.09a.919.919,0,0,0-.794,0L.521,15.266a.918.918,0,0,0,0,1.655L32.148,32.1a.919.919,0,0,0,.794,0L58.826,19.671v7.164A2.455,2.455,0,0,0,58.453,31l-.722,6.3h4.393L61.4,31a2.455,2.455,0,0,0-.373-4.161V18.621l3.541-1.7a.917.917,0,0,0,0-1.655Z",
    transform: "translate(0 0)",
    fill: "#1e4171"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationIcon);
export default __webpack_public_path__ + "static/media/education-icon.6ddad02d22c546ea422cd020490e20fb.svg";
export { ForwardRef as ReactComponent };